import {useState} from 'react';
import StakingButton from './staking-button';

function getAttr(nft, attr) {
  const attribute = nft.json.attributes?.find(a => a.trait_type === attr);
  return attribute?.value;
}

function getStars(nft) {
  const rarity = getAttr(nft, 'Rarity');
  const numStars = parseInt(rarity);
  let stars = [];
  for (let i = 0; i < numStars; i++) {
    stars.push(<i className="fa-solid fa-star"></i>);
  }
  return <span>{stars}</span>;
}

export default function Nft({nft, onClick, superOg}) {
  const [open, setOpen] = useState(false);

  const onImageClick = () => {
    if (onClick) {
      onClick(nft);
    }
  }
  return (
    <div key={nft.json.name} className="h-fit grow flex justify-center justify-items-center align-top p-2">
      <div className={`container bg-zinc-700 rounded-lg ${superOg ? 'w-40' : 'max-w-sm'}`}>
        <div className={`${superOg ? 'text-xs' : 'text-xl'} font-medium text-center p-2`}>
          {nft.json.name || 'Unknown NFT'} <span className="pull-right">{getStars(nft)}</span></div>
        <img className={superOg ? 'h-40 ' : null} src={nft.json.image} onClick={onImageClick}/>
        {
          onClick ?
              null
              :
              <StakingButton nft={nft}/>
        }
        <div
          tabIndex="0"
          className={`collapse collapse-arrow ${open ? 'collapse-open' : 'collapse-close'}`}
        >
          <div className="collapse-title text-xl font-medium" onClick={()=>setOpen(!open)}>Details</div>
          <div className="collapse-content">
            {
              nft.json?.attributes?.map(a=>{
                return <p><b>{a.trait_type}:</b> {a.value}</p>
              })
            }
          </div>
        </div>
      </div>
    </div>
  );
}
